module.exports = __webpack_public_path__ + "assets/img/register-samsung.654ab1ee.jpg";